
interface Props {
  sm: string
  md: string
  lg: string
  xl: string
}

const breakpoints: Props = {
  sm: `@media (min-width: 576px)`,
  md: `@media (min-width: 768px)`,
  lg: `@media (min-width: 992px)`,
  xl: `@media (min-width: 1200px)`
}

export enum screens {
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200
}

export const minWidth = (width: number) => `@media (min-width: ${width}px)`

export default breakpoints